// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 设置项类型枚举 枚举类
 * 设置项类型枚举，决定输入与输出
 */
export enum EnumSettingItemType {
  /** 布尔型 : 布尔型 */
  Boolean = 1,
  /** 文本型 : 文本型 */
  Text = 2,
  /** 数字 : 数字 */
  Number = 4,
  /** 单项选择型 : 选择型需要选项 */
  SingleSelect = 8,
  /** 多项选择型 : 选择型需要选项 */
  MultiSelect = 16,
  /** 日期时间 : 日期时间 */
  DateTime = 32,
  /** 日期 : 日期 */
  Date = 64,
  /** 时间 : 时间 */
  Time = 128
}

/**
 * 设置项类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumSettingItemTypeMD {
  private static items = [
    new EnumItemMD('Boolean', 1, '布尔型', '布尔型'),
    new EnumItemMD('Text', 2, '文本型', '文本型'),
    new EnumItemMD('Number', 4, '数字', '数字'),
    new EnumItemMD('SingleSelect', 8, '单项选择型', '选择型需要选项'),
    new EnumItemMD('MultiSelect', 16, '多项选择型', '选择型需要选项'),
    new EnumItemMD('DateTime', 32, '日期时间', '日期时间'),
    new EnumItemMD('Date', 64, '日期', '日期'),
    new EnumItemMD('Time', 128, '时间', '时间')
  ];

  static getItem(enumItem: EnumSettingItemType) {
    return this.items.find(item => item.name === EnumSettingItemType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
